<mat-dialog-actions>
  <div class="dialog-action-btn"><ng-content></ng-content></div>
</mat-dialog-actions>
